/*
 * @Author: 南岸有归
 * @Date: 2020-02-24 09:24:27
 * @LastEditTime: 2020-04-10 11:12:13
 * @LastEditors: 南岸有归
 * @Description:
 * @FilePath: \cloud_frontend\src\api\login.js
 * @
 */
import http from "@/axios/http";
import store from "@/store";
import { getuser_id } from "@/localStorage/localStorage";

//用户密码登录
export function loginByUsername(username, password) {
  const data = {
    username,
    password,
  };
  return http({
    url: "/api/userLogin",
    method: "post",
    data,
  });
}

//邮箱登录
export function emailLogin(email, password) {
  return http({
    url: "/api/emailLogin",
    method: "post",
    data: { email, password },
  });
}

//根据用户id获取客户
export function getUser() {
  console.log(getuser_id());
  const data = {
    user_id: getuser_id(),
  };
  return http({
    url: "/api/user/getUser",
    method: "post",
    data,
  });
}

//设备分布图
export function getDeviceAddressList(offset, limit, allDevice = 2) {
  const data = {
    // user_id: getuser_id(),
    // offset: offset,
    // limit: limit,
    allDevice,
  };
  return http({
    url: "/api/device/getDeviceAddressList",
    method: "post",
    data,
  });
}
//获取首页设备分布，设备在线离线数量
export function getDeviceInformation() {
  return http({
    url: "/api/device/getDeviceInformation",
    method: "get",
  });
}
//获取用户权限列表
export function showFunctionList() {
  const data = {
    user_id: getuser_id(),
    language: 0,
  };
  return http({
    url: "/api/permission/showFunctionList",
    method: "post",
    data,
  });
}
//获取聚合点的信息
export function getMarkerInfo(data) {
  return http({
    url: "/api/device/getDeviceInfo",
    method: "post",
    data,
  });
}
